import React, {Component, useState} from "react"
import {connect} from 'react-redux';

import Layout from "../../../components/Layout"
import FilterReportsFinancial from "../../../components/FilterReports/financial"
import leng from "../../../data"

import {
    DataTableSkeleton, Loading
} from "carbon-components-react"
import "./index.scss"
import {Card} from '@carbon/ibmdotcom-react';
import {
    reports_financial_action_fetch, reports_financial_mongo_action_fetch
} from '../../../store/actions/reports';
import TableGrid from "../../../components/TableReactGrid";

import {Xls20, DocumentWordProcessor20, Warning16, ArrowRight20, Launch20} from "@carbon/icons-react";
import axios from "axios";

const headers = [
    {name: "itens", title: <strong>Itens</strong>},
    {name: "worksheet", title: <strong>Worksheet</strong>},
    {name: "document", title: <strong>Document</strong>},

];

//https://domrock365-my.sharepoint.com/:x:/g/personal/jefferson_domrock_ai/EX3jbf11MdFAsGpI-qQS_pUBu8bYtltCfKoAdkq8fx9Vbg?e=Xe0cHw
//https://domrock365-my.sharepoint.com/:w:/g/personal/jefferson_domrock_ai/Efmka4P0z0VHngPPHtp6sqYBa3iDnyniE_h5TKpHCHFNEA?e=klOzNf


const rowsTable = [
    {
        "id": "1",
        "itens": "Balanço Patrimonial",


    },
    {
        "id": "2",
        "itens": "Demostração do resultado",

    },
    {
        "id": "3",
        "itens": "Demostração do resultado abrangente",

    },
    {
        "id": "4",
        "itens": "Demostração das multações Patromônial Líquido",

    },
    {
        "id": "5",
        "itens": "Demostrações dos Fluxos de Caixa",

    },
    {
        "id": "6",
        "itens": "Contexto Operacional",

    },
    {
        "id": "7",
        "itens": "Base de Preparação",

    }
];

const tableColumnExtensions = [
    {columnName: 'worksheet', width: 150, align: "center"},
    {columnName: 'document', width: 150, align: "center"},
];


class Report extends Component {

    state = {
        form: {
            report: "",
            type: "",
            typeDate: 'mm',
            date: new Date()
        }
    };


    componentDidMount() {
        //     this.props.countFiles();
        //    this.props.fetchData({error: false,skip: 0});
    }

    onSubmitForm(form) {
        this.setState({form: form})
        this.props.fetchDataSearch(form);
        //console.log(form);
    }

    render() {
        let {data, isLoading} = this.props;

        let urlMicrosoftDOCX = "";
        let urlMicrosoftXLSX = "";
        let achou = false;
        if (data.length > 0) {
            achou = true;
            if (data[0].typeDocument == "DOCX") {

                let encodedUrlDOCX = encodeURI(data[0].url);
                urlMicrosoftDOCX = `https://view.officeapps.live.com/op/view.aspx?src=${(encodedUrlDOCX)}`;

                if (typeof data[1] !== typeof undefined) {
                    if (data[1].typeDocument == "XLSX") {
                        let encodedUrlXLSX = encodeURI(data[1].url);
                        urlMicrosoftXLSX = `https://view.officeapps.live.com/op/view.aspx?src=${(encodedUrlXLSX)}`;
                    }
                }
            } else {
                if (typeof data[1] !== typeof undefined) {
                    if (data[1].typeDocument == "DOCX") {
                        let encodedUrlDOCX = encodeURI(data[1].url);
                        urlMicrosoftDOCX = `https://view.officeapps.live.com/op/view.aspx?src=${(encodedUrlDOCX)}`;
                    }
                }
                let encodedUrlXLSX = encodeURI(data[0].url);
                urlMicrosoftXLSX = `https://view.officeapps.live.com/op/view.aspx?src=${(encodedUrlXLSX)}`;
            }

        }

        return (
            <Layout>
                <div className="section">
                    <div className="section-heading">
                        <br/>
                        <p>{leng.sideBar.intelligentJourney.title}</p>
                        <h1>{leng.sideBar.intelligentJourney.links[4]}</h1>
                        <br/>
                    </div>
                </div>
                <div className="section-light">
                    <div className="section-light-heading">
                        <div className="file-upload-container">
                            <div>
                                <FilterReportsFinancial
                                    onSubmitForm={(data) => this.onSubmitForm(data)}
                                    businessId={this.state.form.report}
                                    typeDate={this.state.form.typeDate}
                                    date={this.state.form.date}
                                />
                            </div>

                            <div>
                                {isLoading ? (
                                    <>
                                        <Loading
                                            description="Active loading indicator" withOverlay={true}
                                        />

                                    </>
                                ) : (
                                    <>
                                        {!(achou) ? (<>
                                            <h2 style={{color: "black", paddingBottom: "20px"}}>Result</h2>
                                            <div className="bx--row resource-card-group"
                                                 style={{marginLeft: "0rem", pointerEvents: "none", opacity: "50%"}}>
                                                <div
                                                    className="Grid-module--column--1wV-c bx--no-gutter-sm bx--col-md-2 bx--col-lg-2"
                                                    style={{padding: "0px"}}>
                                                    <div className="bx--resource-card">
                                                        <div className="bx--aspect-ratio bx--aspect-ratio--2x1">
                                                            <div className="bx--aspect-ratio--object"><a

                                                                className="bx--tile bx--tile--clickable"><h5
                                                                className="bx--resource-card__subtitle">Financial
                                                                Statement
                                                                - Word</h5>
                                                                <div className="bx--resource-card__icon--img">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                         viewBox="0 0 48 48" width="32px" height="32px">
                                                                        <path fill="#2d92d4"
                                                                              d="M42.256,6H15.744C14.781,6,14,6.781,14,7.744v7.259h30V7.744C44,6.781,43.219,6,42.256,6z"/>
                                                                        <path fill="#2150a9"
                                                                              d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42h26.513C43.219,42,44,41.219,44,40.256v-7.202H14z"/>
                                                                        <path fill="#2d83d4"
                                                                              d="M14 15.003H44V24.005000000000003H14z"/>
                                                                        <path fill="#2e70c9"
                                                                              d="M14 24.005H44V33.055H14z"/>
                                                                        <path fill="#00488d"
                                                                              d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"/>
                                                                        <path fill="#fff"
                                                                              d="M18.403 19L16.857 26.264 15.144 19 12.957 19 11.19 26.489 9.597 19 7.641 19 9.985 29 12.337 29 14.05 21.311 15.764 29 18.015 29 20.359 19z"/>
                                                                    </svg>
                                                                </div>
                                                                <div className="bx--resource-card__icon--action">
                                                                    <Launch20/>
                                                                </div>
                                                            </a></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="Grid-module--column--1wV-c bx--no-gutter-sm bx--col-md-2 bx--col-lg-2"
                                                    style={{padding: "0px"}}>
                                                    <div className="bx--resource-card">
                                                        <div className="bx--aspect-ratio bx--aspect-ratio--2x1">
                                                            <div className="bx--aspect-ratio--object"><a

                                                                className="bx--tile bx--tile--clickable"><h5
                                                                className="bx--resource-card__subtitle">Financial
                                                                Statement
                                                                - Excel</h5>
                                                                <div className="bx--resource-card__icon--img">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                         viewBox="0 0 48 48" width="32px" height="32px">
                                                                        <path fill="#169154"
                                                                              d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"/>
                                                                        <path fill="#18482a"
                                                                              d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"/>
                                                                        <path fill="#0c8045"
                                                                              d="M14 15.003H29V24.005000000000003H14z"/>
                                                                        <path fill="#17472a"
                                                                              d="M14 24.005H29V33.055H14z"/>
                                                                        <g>
                                                                            <path fill="#29c27f"
                                                                                  d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"/>
                                                                            <path fill="#27663f"
                                                                                  d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"/>
                                                                            <path fill="#19ac65"
                                                                                  d="M29 15.003H44V24.005000000000003H29z"/>
                                                                            <path fill="#129652"
                                                                                  d="M29 24.005H44V33.055H29z"/>
                                                                        </g>
                                                                        <path fill="#0c7238"
                                                                              d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"/>
                                                                        <path fill="#fff"
                                                                              d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"/>
                                                                    </svg>
                                                                </div>
                                                                <div className="bx--resource-card__icon--action">
                                                                    <Launch20/>
                                                                </div>
                                                            </a></div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>

                                        </>) : (<>
                                            <h2 style={{color: "black", paddingBottom: "20px"}}>Result</h2>
                                            <div className="bx--row resource-card-group" style={{
                                                marginLeft: "0rem",
                                                pointerEvents: "visiblePainted",
                                                opacity: "100%"
                                            }}>

                                                <div
                                                    className="Grid-module--column--1wV-c bx--no-gutter-sm bx--col-md-2 bx--col-lg-2"
                                                    style={urlMicrosoftDOCX == "" ? {
                                                        marginLeft: "0rem",
                                                        pointerEvents: "none",
                                                        opacity: "50%",
                                                        padding: "0px"
                                                    } : {padding: "0px"}}
                                                >
                                                    <div className="bx--resource-card">
                                                        <div className="bx--aspect-ratio bx--aspect-ratio--2x1">
                                                            <div className="bx--aspect-ratio--object"><a
                                                                target="_blank" href={urlMicrosoftDOCX}
                                                                className="bx--tile bx--tile--clickable"><h5
                                                                className="bx--resource-card__subtitle">Financial
                                                                Statement
                                                                - Word</h5>
                                                                <div className="bx--resource-card__icon--img">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                         viewBox="0 0 48 48" width="32px" height="32px">
                                                                        <path fill="#2d92d4"
                                                                              d="M42.256,6H15.744C14.781,6,14,6.781,14,7.744v7.259h30V7.744C44,6.781,43.219,6,42.256,6z"/>
                                                                        <path fill="#2150a9"
                                                                              d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42h26.513C43.219,42,44,41.219,44,40.256v-7.202H14z"/>
                                                                        <path fill="#2d83d4"
                                                                              d="M14 15.003H44V24.005000000000003H14z"/>
                                                                        <path fill="#2e70c9"
                                                                              d="M14 24.005H44V33.055H14z"/>
                                                                        <path fill="#00488d"
                                                                              d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"/>
                                                                        <path fill="#fff"
                                                                              d="M18.403 19L16.857 26.264 15.144 19 12.957 19 11.19 26.489 9.597 19 7.641 19 9.985 29 12.337 29 14.05 21.311 15.764 29 18.015 29 20.359 19z"/>
                                                                    </svg>
                                                                </div>
                                                                <div className="bx--resource-card__icon--action">
                                                                    <Launch20/>
                                                                </div>
                                                            </a></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div
                                                    className="Grid-module--column--1wV-c bx--no-gutter-sm bx--col-md-2 bx--col-lg-2"
                                                    style={urlMicrosoftXLSX == "" ? {
                                                        marginLeft: "0rem",
                                                        pointerEvents: "none",
                                                        opacity: "50%",
                                                        padding: "0px"
                                                    } : {padding: "0px"}}
                                                >
                                                    <div className="bx--resource-card">
                                                        <div className="bx--aspect-ratio bx--aspect-ratio--2x1">
                                                            <div className="bx--aspect-ratio--object"><a
                                                                target="_blank" href={urlMicrosoftXLSX}
                                                                className="bx--tile bx--tile--clickable"><h5
                                                                className="bx--resource-card__subtitle">Financial
                                                                Statement
                                                                - Excel</h5>
                                                                <div className="bx--resource-card__icon--img">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                         viewBox="0 0 48 48" width="32px" height="32px">
                                                                        <path fill="#169154"
                                                                              d="M29,6H15.744C14.781,6,14,6.781,14,7.744v7.259h15V6z"/>
                                                                        <path fill="#18482a"
                                                                              d="M14,33.054v7.202C14,41.219,14.781,42,15.743,42H29v-8.946H14z"/>
                                                                        <path fill="#0c8045"
                                                                              d="M14 15.003H29V24.005000000000003H14z"/>
                                                                        <path fill="#17472a"
                                                                              d="M14 24.005H29V33.055H14z"/>
                                                                        <g>
                                                                            <path fill="#29c27f"
                                                                                  d="M42.256,6H29v9.003h15V7.744C44,6.781,43.219,6,42.256,6z"/>
                                                                            <path fill="#27663f"
                                                                                  d="M29,33.054V42h13.257C43.219,42,44,41.219,44,40.257v-7.202H29z"/>
                                                                            <path fill="#19ac65"
                                                                                  d="M29 15.003H44V24.005000000000003H29z"/>
                                                                            <path fill="#129652"
                                                                                  d="M29 24.005H44V33.055H29z"/>
                                                                        </g>
                                                                        <path fill="#0c7238"
                                                                              d="M22.319,34H5.681C4.753,34,4,33.247,4,32.319V15.681C4,14.753,4.753,14,5.681,14h16.638 C23.247,14,24,14.753,24,15.681v16.638C24,33.247,23.247,34,22.319,34z"/>
                                                                        <path fill="#fff"
                                                                              d="M9.807 19L12.193 19 14.129 22.754 16.175 19 18.404 19 15.333 24 18.474 29 16.123 29 14.013 25.07 11.912 29 9.526 29 12.719 23.982z"/>
                                                                    </svg>
                                                                </div>
                                                                <div className="bx--resource-card__icon--action">
                                                                    <Launch20/>
                                                                </div>
                                                            </a></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>)}

                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Layout>
        )
    }
}

const
    mapStateToProps = ({reports}) => reports;

const
    mapDispatchToProps = dispatch => ({
        fetchData: params => dispatch(reports_financial_action_fetch(params)),
        fetchDataSearch: params => dispatch(reports_financial_mongo_action_fetch(params)),
    });

export default connect(
    mapStateToProps,
    mapDispatchToProps
)

(
    Report
)
;
